// ============================================================================
// JUMP SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'jump-search',
  name: 'Jump Search',
  category: 'Search',
  complexity: {
    time: 'O(√n)',
    space: 'O(1)'
  },
  description: 'Jump Search jumps ahead by fixed steps to find the target block, then performs linear search within that block. It has O(√n) time complexity.'
};
export type MetaType = typeof meta;
